import React, { Component } from 'react';
import Container from '../../v2/container';
import LocationPairList from './LocationPairList';
import List from './List';

export default class extends Component {
  render() {
    return (
      <Container className="py-10">
        <div className="mb-6">
          <LocationPairList />
        </div>
        <List />
      </Container>
    );
  }
}
